import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  descriptionText: {
    margin: 0,
    color: theme.palette.text.secondary,
  },
  selectedExamPaperTitle: {
    color: theme.palette.text.primary,
    fontWeight: 700,
  },
  sectionContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  sectionTitle: {
    fontWeight: 600,
  },
  resultSectionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    flexWrap: 'wrap',
  },
  resultSectionTitle: {
    '&::before': {
      content: '""',
      display: 'inline-block',
      height: 16,
      width: 3,
      backgroundColor: 'red',
      marginRight: 10,
      borderTopLeftRadius: 2,
      position: 'relative',
      top: 2,
    },
  },
  actionButton: {
    minWidth: 100,
  },
  resultTableWrapper: {
    width: '100%',
    border: `1px solid ${theme.palette.divider}`,
  },
  resultRadioGroup: {
    width: '100%',
    height: 'clamp(150px, 35vh, 420px)',
    maxHeight: 'min(35vh, 420px)',
  },
  resultRadioGroupEmpty: {
    height: 'clamp(150px, 35vh, 420px)',
    maxHeight: 'min(35vh, 420px)',
  },
  resultTable: {
    borderCollapse: 'separate',
    minWidth: '100%',
    width: 'max-content',
    tableLayout: 'auto',
  },
  tableHeaderCell: {
    backgroundColor: theme.palette.background.paper,
    whiteSpace: 'nowrap',
    fontWeight: 600,
  },
  tableBodyCell: {
    whiteSpace: 'nowrap',
  },
  emptyTableBody: {
    '& .MuiTableCell-root': {
      borderBottom: 'none',
    },
  },
  selectedTableBodyCell: {
    backgroundColor: theme.palette.action.selected,
  },
  candidateCellContent: {
    display: 'flex',
    alignItems: 'center',
  },
  candidateRadioLabel: {
    marginLeft: 0,
    marginRight: 0,
  },
  candidateRadio: {
    padding: 0,
    marginRight: 9,
  },
  clearFilterButton: {
    padding: 4,
  },
  selectableTableRow: {
    cursor: 'pointer',
    '&.Mui-selected': {
      backgroundColor: theme.palette.action.selected,
    },
    '&.Mui-selected:hover': {
      backgroundColor: theme.palette.action.selected,
    },
  },
}));
